import React from "react";
import { Gem } from "lucide-react";
import { useApp } from "../context/AppContext";

const MARQUEE_PASSES = ["primary", "duplicate"];

export default function BrandMarquee() {
  const { t } = useApp();
  const items = t.showcase;

  return (
    <div className="relative bg-[#ECE8DF] border-y border-black/10 overflow-hidden py-7" data-testid="brand-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#ECE8DF] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#ECE8DF] to-transparent" />

      <div className="flex w-max animate-marquee">
        {MARQUEE_PASSES.flatMap((pass) => items.map((car) => (
          <div key={`${pass}-${car.brand}-${car.model}`} className="flex shrink-0 items-center">
            <div className="flex items-center gap-4 px-8 sm:px-12">
              <div className="text-left">
                <div className="font-mono-jb text-[11px] uppercase tracking-[0.25em] text-teal-800 sm:text-xs">{car.brand}</div>
                <div className="font-syne text-2xl font-extrabold uppercase leading-none tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">{car.model}</div>
                <div className="mt-1 text-xs italic text-slate-700 sm:text-sm">{car.tagline}</div>
              </div>
            </div>
            <Gem size={18} className="mx-2 shrink-0 text-teal-800 sm:mx-4" />
          </div>
        )))}
      </div>
    </div>
  );
}
